import { Injectable, signal } from '@angular/core';
import { UserInfo } from '../../shared/models/auth.models';

const REFRESH_TOKEN_HINT_KEY = 'tb_rt_hint';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly accessToken = signal<string | null>(null);
  readonly currentUser = signal<UserInfo | null>(null);

  getAccessToken(): string | null {
    return this.accessToken();
  }

  setTokens(accessToken: string, user: UserInfo): void {
    this.accessToken.set(accessToken);
    this.currentUser.set(user);
    localStorage.setItem(REFRESH_TOKEN_HINT_KEY, '1');
  }

  clearTokens(): void {
    this.accessToken.set(null);
    this.currentUser.set(null);
    localStorage.removeItem(REFRESH_TOKEN_HINT_KEY);
  }

  hasRefreshToken(): boolean {
    return localStorage.getItem(REFRESH_TOKEN_HINT_KEY) !== null;
  }

  isAuthenticated(): boolean {
    return this.accessToken() !== null;
  }
}
